export * from './callback.service';
import { CallbackService } from './callback.service';
export * from './prepaidPackage.service';
import { PrepaidPackageService } from './prepaidPackage.service';
export * from './stripe.service';
import { StripeService } from './stripe.service';
export const APIS = [CallbackService, PrepaidPackageService, StripeService];
